(() => {
  if (window.runzieBundleSelectLoaded) return;
  window.runzieBundleSelectLoaded = true;
  let opened = null, serial = 0;
  function close(focus = false) {
    if (!opened) return;
    const {button,list,wrapper} = opened;
    list.hidden = true; button.setAttribute('aria-expanded','false'); wrapper.classList.remove('is-open');
    if (focus) button.focus();
    opened = null;
  }
  function enhance(select) {
    if (select.dataset.customized) return;
    select.dataset.customized = 'true';
    const wrapper = document.createElement('div');wrapper.className = 'rb-custom-select';
    select.before(wrapper);wrapper.append(select);
    select.hidden = true;
    const button = document.createElement('button');button.type = 'button';button.className = 'rb-select-trigger';
    button.setAttribute('aria-haspopup','listbox');button.setAttribute('aria-expanded','false');
    const list = document.createElement('div');list.className = 'rb-select-menu';list.id = `rb-options-${++serial}`;
    list.setAttribute('role','listbox');list.setAttribute('aria-label',select.getAttribute('aria-label') || 'Choose size');list.hidden = true;
    button.setAttribute('aria-controls',list.id);
    const choices = [];
    [...select.options].filter(option => option.value).forEach(option => {
      const choice = document.createElement('button');choice.type = 'button';choice.className = 'rb-select-option';
      choice.setAttribute('role','option');choice.textContent = option.textContent;choice.dataset.value = option.value;
      choice.disabled = option.disabled;choice.setAttribute('aria-disabled',String(option.disabled));choice.tabIndex=-1;
      choice.addEventListener('click', () => {
        if (select.disabled || choice.disabled) return;
        select.value = option.value;sync();close(true);select.dispatchEvent(new Event('change',{bubbles:true}));
      });
      list.append(choice);choices.push(choice);
    });
    function sync() {
      button.textContent = select.selectedOptions[0]?.textContent || 'Select an option';
      button.disabled = select.disabled;
      button.setAttribute('aria-label',`${select.getAttribute('aria-label') || 'Choose size'}: ${button.textContent}`);
      choices.forEach(choice => choice.setAttribute('aria-selected',String(choice.dataset.value === select.value)));
      if (select.disabled && opened?.button === button) close();
    }
    function open(last = false) {
      if (select.disabled) return;
      close();sync();list.hidden=false;button.setAttribute('aria-expanded','true');wrapper.classList.add('is-open');
      opened={button,list,wrapper};
      const enabled=choices.filter(c=>!c.disabled);
      (enabled.find(c=>c.dataset.value===select.value) || (last ? enabled.at(-1) : enabled[0]))?.focus();
    }
    button.addEventListener('click',()=> opened?.button===button ? close() : open());
    button.addEventListener('keydown',e=>{if (['ArrowDown','ArrowUp'].includes(e.key)){e.preventDefault();open(e.key==='ArrowUp');}});
    list.addEventListener('keydown',e=>{
      if (e.key==='Escape'){e.preventDefault();e.stopPropagation();close(true);return;}
      if (e.key==='Tab'){close(true);return;}
      const enabled=choices.filter(c=>!c.disabled);let index=enabled.indexOf(document.activeElement);
      if (['ArrowDown','ArrowUp','Home','End'].includes(e.key)) {
        e.preventDefault();index=e.key==='Home'?0:e.key==='End'?enabled.length-1:(index+(e.key==='ArrowDown'?1:-1)+enabled.length)%enabled.length;enabled[index]?.focus();
      } else if (e.key.length===1 && !e.ctrlKey && !e.metaKey) enabled.find(c=>c.textContent.trim().toLowerCase().startsWith(e.key.toLowerCase()))?.focus();
    });
    select.addEventListener('change',sync);
    wrapper.append(button,list);sync();
    // Synchronize loading/disabled states without retaining detached selects.
    select._rbSync = sync;
  }
  function scan() {
    document.querySelectorAll('runzie-bundle [data-variant]').forEach(enhance);
    if (opened && (!opened.wrapper.isConnected || opened.wrapper.closest('[data-activity-panel][hidden]'))) close();
  }
  document.addEventListener('pointerdown',e=>{if (opened && !opened.wrapper.contains(e.target))close();});
  new MutationObserver(records=>{
    if (records.some(r=>r.type==='childList'))scan();
    records.forEach(r=>{if(r.type==='attributes' && r.target.matches('select[data-variant]'))r.target._rbSync?.();});
  }).observe(document.documentElement,{childList:true,subtree:true,attributes:true,attributeFilter:['disabled','hidden']});
  scan();
})();
